import { LOYALTY_ACCOUNT_DATA } from '../constants/local-storage-constants';

export interface ILocalStorageSavedLoyaltyAccountData {
  loyaltyAccountIdentifier: string;
  loyaltyTypePRO: boolean;
  expiry: number;
}

export type ISavedLoyaltyAccountData = Omit<ILocalStorageSavedLoyaltyAccountData, 'expiry'> | null;

export const getLoyaltyAccountDataKey = (customerNumber: string) =>
  `${LOYALTY_ACCOUNT_DATA}_${customerNumber}`;

export const removeLoyaltyAccountDataKey = (customerNumber: string) => {
  localStorage.removeItem(getLoyaltyAccountDataKey(customerNumber));
};

export const savedLoyaltyAccountData = (customerNumber: string): ISavedLoyaltyAccountData => {
  const restoredLoyaltyAccountData = localStorage.getItem(getLoyaltyAccountDataKey(customerNumber));

  if (restoredLoyaltyAccountData) {
    const accountData: ILocalStorageSavedLoyaltyAccountData = JSON.parse(restoredLoyaltyAccountData);

    if (new Date().getTime() > accountData.expiry) {
      removeLoyaltyAccountDataKey(customerNumber);
      return null;
    } else {
      return {
        loyaltyAccountIdentifier: accountData.loyaltyAccountIdentifier,
        loyaltyTypePRO: accountData.loyaltyTypePRO,
      };
    }
  }

  return null;
};
